<script>
  import Subsection from "../../../../../components/layout/Subsection.svelte";
  import SubsectionTitle from "../../../../../components/layout/SubsectionTitle.svelte";
  import PrimaryBorderedButton from "../../../../../components/button/generic/PrimaryBorderedButton.svelte";
  import HelpTooltip from "../../../../../components/tooltip/HelpTooltip.svelte";
  import { downloadFile } from "../../../../../utils/download.js";
  import { getNotificationsContext } from "svelte-notifications";
  import UpdateEProtectorSubsection from "../UpdateEProtectorSubsection.svelte";
  import ApplyCancelFileDialog from "../ApplyCancelFileDialog.svelte";
  import { translate } from "../../../../../i18n/i18next.js";

  const {addNotification} = getNotificationsContext()

  let isApplyCancelFileDialogOpen = false

  async function onClickRetrieveCreateLog() {
    const response = await fetch("/api/license/e-protector/create-log")
    const responseData = await response.json().catch(() => null)
    if (response.ok && responseData) {
      downloadFile(new Blob([responseData.log]), responseData.filename)
      addNotification({
        text: translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.messages.createLogDownloaded"),
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });
    } else {
      addNotification({
        text: translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.messages.createLogDownloadFailed"),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
    }
  }

</script>

<UpdateEProtectorSubsection />
<Subsection>
  <SubsectionTitle>{translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.title")}</SubsectionTitle>
  <div class="subsection-content">
    {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.caption1")}
    <!-- TODO: replace the link with the actual one
    <a href={translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.caption2Href")} target="_blank">
      {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.caption2")}
    </a>
    -->
  </div>
  <div class="subsection-content-button">
    <HelpTooltip title={translate("generic.license.hasp.createLogFile")}>
      {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.createLog.tooltip")}
    </HelpTooltip>
    <PrimaryBorderedButton onClick={onClickRetrieveCreateLog}>
      {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.createLog.label")}
    </PrimaryBorderedButton>
  </div>
  <div class="subsection-content-button">
    <HelpTooltip title={translate("generic.license.hasp.cancelFile")}>
      {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.cancelFile.tooltip")}
      <br />
      <span style="color: crimson">
        {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.cancelFile.warning")}
      </span>
    </HelpTooltip>
    <PrimaryBorderedButton onClick={() => isApplyCancelFileDialogOpen = true}>
      {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.move.cancelFile.label")}
    </PrimaryBorderedButton>
  </div>
</Subsection>
{#if isApplyCancelFileDialogOpen}
  <ApplyCancelFileDialog onClose={() => isApplyCancelFileDialogOpen = false} />
{/if}

<style>
  .subsection-content-button {
    align-self: end;
  }
</style>
